/**
 * Header cart vs wishlist count badges.
 *
 * UX: Different hues for instant scanning. Cart = brand indigo (“in my bag”, checkout path).
 * Wishlist = warm amber/gold (“my shortlist”, curated picks) — positive and premium-feeling,
 * not error red and not competing with the cart’s commerce cue.
 */
export const NAV_BADGE_CART_DESKTOP =
  'absolute -top-1 -right-1 min-w-[12px] h-3 px-1 flex items-center justify-center rounded-full bg-[#3B3B98] text-white text-[10px] font-semibold tabular-nums shadow-sm ring-1 ring-white/90';

export const NAV_BADGE_WISHLIST_DESKTOP =
  'absolute -top-1 -right-1 min-w-[12px] h-3 px-1 flex items-center justify-center rounded-full bg-amber-600 text-white text-[10px] font-semibold tabular-nums shadow-sm ring-1 ring-white/90';

/** Mobile drawer rows (slightly larger tap targets). */
export const NAV_BADGE_CART_DRAWER =
  'min-w-[16px] h-4 px-1 flex items-center justify-center rounded-full bg-[#3B3B98] text-white text-xs font-semibold tabular-nums';

export const NAV_BADGE_WISHLIST_DRAWER =
  'min-w-[16px] h-4 px-1 flex items-center justify-center rounded-full bg-amber-600 text-white text-xs font-semibold tabular-nums';
